var map = {
	"./de-DE/img_logo.png": "ed81",
	"./en-GB/img_logo.png": "e13a",
	"./en-US/img_logo.png": "2cb2",
	"./es-ES/img_logo.png": "41cc",
	"./es-MX/img_logo.png": "c1d8",
	"./fr-CA/img_logo.png": "275f",
	"./fr-FR/img_logo.png": "ebb0",
	"./it-IT/img_logo.png": "4450",
	"./ja-JP/img_logo.png": "edd9",
	"./pt-BR/img_logo.png": "c4a0",
	"./zh-TW/img_logo.png": "f1cd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2e0d";